export enum PublishedTypeEnum {
  NOW = 'NOW',
  PERIOD = 'PERIOD',
}
